var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seccion-header"},_vm._l((_vm.items),function(item){return _c('div',{key:item},[_c('div',{staticClass:"container-text"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/images-new/icons/check-orange.svg","alt":"check","height":"14"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0713086e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/advisers/seccion-header.vue
// module id = 992
// module chunks = 9